import http from '../../../services/api'
import {
  buildInventoryMovementSummaryQuery,
  type InventoryMovementSummaryParams,
  type InventoryMovementSummaryResponse,
} from '../inventoryMovementSummaryModel'

const apiPath = import.meta.env.VITE_API_PATH

async function getInventoryMovementSummary(params: InventoryMovementSummaryParams) {
  const query = buildInventoryMovementSummaryQuery(params)

  return await http.get<InventoryMovementSummaryResponse>(`${apiPath}reports/inventory-movement-summary?${query}`, {
    errorHandle: false,
    timeout: 30000,
  } as any)
}

export default {
  getInventoryMovementSummary,
}
